import React, { useEffect } from 'react';

const MagicLink: React.FC = () => {
	useEffect(() => {
		const handleRedirect = () => {
			console.log('redirecting...');
			try {
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							type: 'SDK_RESPONSE',
							response: 'FINISHED'
						})
					);
				}
			} catch (err) {
				console.error(err);
			}
		};
		handleRedirect();
	}, []);

	return (
		<div className="w-full h-screen flex items-center justify-center">
			<div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#1E6091]"></div>
		</div>
	);
};

declare global {
	interface Window {
		ReactNativeWebView?: {
			postMessage(message: string): void;
		};
	}
}
export default MagicLink;
